import { SET_REDIRECT_ROUTE } from 'root/src/client/logic/route/actionIds'

const setRedirectRoute = route => ({
	type: SET_REDIRECT_ROUTE,
	payload: route,
})

export default setRedirectRoute
